var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailsentRafiki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-92"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.26,
    y: 392.99,
    width: 34.4,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.68,
    y: 393.11,
    width: 19.36,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.76,
    y: 392.53,
    width: 39.24,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.22,
    y: 388.97,
    width: 17.54,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.57,
    y: 389.1,
    width: 52.99,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.31,257.23c-12.3-18.73-1.07-38.86-2.94-59.7s-21.67-25.38-17.92-43c4.34-20.48-7.23-40.13-20.34-40.13S373.44,134,377.78,154.5c3.75,17.65-16,22.2-17.92,43s9.36,41-2.95,59.7-9.07,43.53-2.14,55.84a47.73,47.73,0,0,0,6.62,9.05,50.19,50.19,0,0,0,73.45,0,48.13,48.13,0,0,0,6.61-9.05C448.39,300.76,451.62,276,439.31,257.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.11,271.44h0a6.22,6.22,0,0,1,6.22,6.22V382.4a0,0,0,0,1,0,0H391.89a0,0,0,0,1,0,0V277.66A6.22,6.22,0,0,1,398.11,271.44Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.91,382.4H303V277.67a8.49,8.49,0,0,1,8.47-8.47h0a8.49,8.49,0,0,1,8.47,8.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.44,
    cy: 301.98,
    r: 52.17,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.79,
    cy: 281.38,
    r: 20.56,
    transform: "translate(-5.34 555.92) rotate(-76.05)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.25,
    cy: 269.2,
    r: 12.17,
    transform: "translate(-39.74 491.67) rotate(-80.75)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.48,
    cy: 262.9,
    r: 8.54,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,319.89a56.55,56.55,0,0,0-22.72,8.67c-.06-7.92-1.51-15.43-5.23-21.5-5.66,5.51-10.25,12.65-14,20.33C160.68,313,156.89,299,148.5,290.13c-12.57,7.91-19.05,21.09-22.13,35.05A63.47,63.47,0,0,0,104.9,302c-7.69,8.1-10.15,19.3-9.94,30.78-8.74-10.18-18.44-18.12-27.9-19.05C64.73,329.82,69.69,345,76,357a47.92,47.92,0,0,0,42.47,25.41h41.09c17.51,0,33.93-9.34,42.14-24.81C206.89,347.8,209.37,335.19,204,319.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.26,112.14c5.07-14.87,1-25.46-11.37-25.46-7.78,0-17.43,4.17-26.83,10.95-1.06-3.87-4.05-6.18-8.86-6.18-8.47,0-20.14,7.16-29.29,17.26a14,14,0,0,0-9.54-3.85c-8.11-.46-17.92,3.66-26.45,10.35a4.61,4.61,0,0,0-3.76-1.93c-4.67-.26-11,3.9-14.13,9.28-.19.33-.36.66-.54,1H194.72C195.12,118.86,194.29,114.94,192.26,112.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.67,202.43c2.48-7.26.51-12.43-5.55-12.43-3.81,0-8.52,2-13.11,5.35a4.06,4.06,0,0,0-4.33-3c-4.13,0-9.83,3.5-14.31,8.44a6.79,6.79,0,0,0-4.66-1.88c-4-.23-8.75,1.78-12.92,5.05A2.25,2.25,0,0,0,136,203c-2.28-.13-5.37,1.9-6.9,4.53l-.27.48h65.08A8.17,8.17,0,0,0,192.67,202.43Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.77,147.49a11.31,11.31,0,0,0-1.55-.11c.48-7.25-2.29-11.89-8.22-11.89-4.27,0-9.52,2.42-14.86,6.51,1.53-14.08-3.37-23.23-14.47-23.23-8.94,0-20.27,6-31.46,15.66-1-5.52-4.28-8.84-9.82-8.84-9.73,0-23.56,10.24-34.65,24.68h0A14,14,0,0,0,217,144.74c-9.26-.65-20.77,5.23-31,14.81a4.73,4.73,0,0,0-4.21-2.75c-5.07-.36-12,4.93-16.11,12H350.92C355.27,158.08,351.81,148.7,342.77,147.49Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-92"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mail--inject-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "48.86 150.56 276.83 183.38 307.42 214.25 48.86 150.56",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.86 150.56 276.83 183.38 307.42 214.25 48.86 150.56",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.86 150.56 276.83 183.38 266.25 228.02 48.86 150.56",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.86 150.56 276.83 183.38 266.25 228.02 48.86 150.56",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.57,98.88l13.23,62a6.25,6.25,0,0,1-4.8,7.41l-118.08,25.2a6.26,6.26,0,0,1-7.41-4.8l-13.24-62a6.26,6.26,0,0,1,4.81-7.41l118.08-25.2a6.26,6.26,0,0,1,7.41,4.81Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.57,98.88l13.23,62a6.25,6.25,0,0,1-4.8,7.41l-118.08,25.2a6.26,6.26,0,0,1-7.41-4.8l-13.24-62a6.26,6.26,0,0,1,4.81-7.41l118.08-25.2a6.26,6.26,0,0,1,7.41,4.81Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.66,94.82l-39.45,48.43a25.43,25.43,0,0,1-31.15,6.65l-55.79-28.1a6.22,6.22,0,0,1,3.81-2.53l118.08-25.2A6.23,6.23,0,0,1,258.66,94.82Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.86 150.56 236.89 195.25 266.25 228.02 48.86 150.56",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.86 150.56 236.89 195.25 266.25 228.02 48.86 150.56",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.15,
    y: 188.08,
    width: 1,
    height: 24.25,
    transform: "translate(-109.61 209.15) rotate(-59.64)",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.62,
    y: 209.59,
    width: 1,
    height: 8.72,
    transform: "translate(-109.87 236.19) rotate(-59.64)",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.86 150.56 236.89 195.25 200.34 239.3 48.86 150.56",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.36,255.26a2,2,0,0,1-.74-.14L269,243a2,2,0,0,1,1.47-3.72L301.1,251.4a2,2,0,0,1-.74,3.86Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.36,255.26a2,2,0,0,1-.74-.14L269,243a2,2,0,0,1,1.47-3.72L301.1,251.4a2,2,0,0,1-.74,3.86Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.55,237.7a1.91,1.91,0,0,1-.73-.15L281.37,231a2,2,0,1,1,1.47-3.72l16.45,6.52a2,2,0,0,1,1.13,2.59A2,2,0,0,1,298.55,237.7Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.55,237.7a1.91,1.91,0,0,1-.73-.15L281.37,231a2,2,0,1,1,1.47-3.72l16.45,6.52a2,2,0,0,1,1.13,2.59A2,2,0,0,1,298.55,237.7Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.16,255a2.1,2.1,0,0,1-.73-.14L233.56,243a2,2,0,1,1,1.47-3.72L264.9,251.1a2,2,0,0,1-.74,3.86Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.16,255a2.1,2.1,0,0,1-.73-.14L233.56,243a2,2,0,1,1,1.47-3.72L264.9,251.1a2,2,0,0,1-.74,3.86Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.3,164.82c2.65,5.17,5.08,10.35,7.39,15.65s4.46,10.67,6.34,16.3l.68,2.13c.12.38.29,1,.39,1.44s.19.94.24,1.36a35.31,35.31,0,0,1,.35,4.87,87.3,87.3,0,0,1-.42,9,144.16,144.16,0,0,1-2.72,17.22l-5.49-.61c-.07-5.63-.12-11.32-.32-16.87-.09-2.76-.25-5.53-.53-8.13a30.52,30.52,0,0,0-.6-3.63c-.05-.28-.13-.49-.19-.72s-.12-.31-.22-.61l-.76-1.89c-2.09-5.06-4.44-10.16-6.84-15.24l-7.26-15.24Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.14,230.42l-2.56,4.79,8.18,2.28s1.56-3.85-.3-6.89Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.45 242.11 380.97 242.71 384.76 237.49 376.58 235.21 373.45 242.11",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.87,130.26c-.11.59-.52,1-.9.92s-.59-.61-.47-1.19.52-1,.9-.92S338,129.68,337.87,130.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.41,131.26a21.34,21.34,0,0,1-3.79,4.41,3.44,3.44,0,0,0,2.67,1.08Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.65,127.47a.36.36,0,0,1-.25-.11,2.78,2.78,0,0,0-2.33-.94.35.35,0,0,1-.12-.68,3.4,3.4,0,0,1,3,1.15.35.35,0,0,1,0,.49A.36.36,0,0,1,340.65,127.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.41,138.43c-1.05,5.38-2.1,15.22,1.66,18.81,0,0-1.47,5.45-11.46,5.45-11,0-5.24-5.45-5.24-5.45,6-1.43,5.83-5.88,4.79-10.05Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.58,160.63c.79-2.63,1.66-5.64-.14-6.59-2-1-12.87-2.1-16.62-.15s-2.68,7.3-2.68,7.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.64,410a2.35,2.35,0,0,1-1.76-.48.71.71,0,0,1,0-.83.83.83,0,0,1,.55-.41c1.08-.24,3.1,1.14,3.19,1.2a.2.2,0,0,1,.07.18.16.16,0,0,1-.13.13A9.34,9.34,0,0,1,380.64,410Zm-.92-1.4-.21,0a.47.47,0,0,0-.32.24c-.16.28-.06.4,0,.44.31.42,1.81.42,2.91.24A5.78,5.78,0,0,0,379.72,408.62Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.52,409.82l-.08,0c-.76-.42-2.23-2-2.08-2.84a.57.57,0,0,1,.56-.46,1,1,0,0,1,.74.22c.85.7,1,2.82,1,2.91a.16.16,0,0,1-.08.16A.14.14,0,0,1,382.52,409.82Zm-1.48-3H381c-.23,0-.25.14-.26.18-.09.49.85,1.7,1.6,2.27a4.19,4.19,0,0,0-.86-2.3A.64.64,0,0,0,381,406.84Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.53,410c-.94,0-1.85-.13-2.16-.55a.66.66,0,0,1,0-.76.88.88,0,0,1,.56-.41c1.21-.33,3.79,1.13,3.9,1.19a.18.18,0,0,1,.08.18.17.17,0,0,1-.14.14A12.17,12.17,0,0,1,336.53,410Zm-1.17-1.42a1.15,1.15,0,0,0-.33,0,.51.51,0,0,0-.34.24c-.13.22-.08.32,0,.38.33.46,2.19.49,3.57.3A7.87,7.87,0,0,0,335.36,408.6Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.75,409.82l-.07,0c-.89-.39-2.64-2-2.51-2.81,0-.2.17-.44.65-.49a1.22,1.22,0,0,1,1,.3c.94.76,1.13,2.74,1.14,2.83a.17.17,0,0,1-.07.16A.17.17,0,0,1,338.75,409.82Zm-1.79-3h-.11c-.31,0-.33.16-.34.2-.08.5,1.12,1.75,2,2.29a4,4,0,0,0-1-2.26A.87.87,0,0,0,337,406.84Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.83 409.64 339.48 409.64 338.75 392.63 346.1 392.63 346.83 409.64",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.94 409.64 383.59 409.64 379.9 392.63 387.24 392.63 390.94 409.64",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.07,408.79h8.25a.65.65,0,0,1,.63.51l1.45,6.53a1.08,1.08,0,0,1-1.08,1.3c-2.88-.05-4.28-.22-7.91-.22-2.23,0-6.83.24-9.92.24s-3.48-3-2.22-3.33c5.66-1.24,7.79-2.95,9.6-4.57A1.78,1.78,0,0,1,383.07,408.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.53,408.79h8a.65.65,0,0,1,.63.51l1.45,6.53a1.07,1.07,0,0,1-1.06,1.3c-2.89-.05-7.07-.22-10.71-.22-4.25,0-7.93.24-12.92.24-3,0-3.85-3-2.59-3.33,5.75-1.26,10.44-1.39,15.41-4.45A3.36,3.36,0,0,1,339.53,408.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,170.14a169.18,169.18,0,0,1-18.31-2.43c-3-.58-6.06-1.23-9.1-2.05a73.14,73.14,0,0,1-9.16-3c-.77-.32-1.55-.67-2.32-1a20.47,20.47,0,0,1-2.5-1.46c-1.44-.95-2.68-1.94-3.91-2.92-2.45-2-4.72-4-7-6.05-4.47-4.14-8.71-8.42-12.8-12.92l3.68-4.11,14.51,10.43c2.39,1.72,4.81,3.41,7.19,5,1.18.79,2.39,1.53,3.5,2.16a12.16,12.16,0,0,0,1.44.7c.59.23,1.19.46,1.82.68a108,108,0,0,0,16.53,3.7c5.71.9,11.61,1.64,17.31,2.24Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.22,158.9c6.89,1.58,13.85,21.71,13.85,21.71L368.9,190.78s-4-9.38-7.86-17.58C357,164.61,362.18,157.29,369.22,158.9Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.22,158.9c6.89,1.58,13.85,21.71,13.85,21.71L368.9,190.78s-4-9.38-7.86-17.58C357,164.61,362.18,157.29,369.22,158.9Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.25,169.9l-2.81,6.29c2.91,6.28,5.57,12.5,6.28,14.16C368.62,182.92,367.21,173.7,365.25,169.9Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.25,169.9l-2.81,6.29c2.91,6.28,5.57,12.5,6.28,14.16C368.62,182.92,367.21,173.7,365.25,169.9Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.07,159.28s-7.82,8.83-.44,63.5h39.29c.28-6-3.51-35.46,2.3-63.88a102.56,102.56,0,0,0-13.15-1.66,145.27,145.27,0,0,0-16.7,0A73.5,73.5,0,0,0,328.07,159.28Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.07,159.28s-7.82,8.83-.44,63.5h39.29c.28-6-3.51-35.46,2.3-63.88a102.56,102.56,0,0,0-13.15-1.66,145.27,145.27,0,0,0-16.7,0A73.5,73.5,0,0,0,328.07,159.28Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.16,169.9c-.26,2.07-.46,4.52-.59,7.41a41.08,41.08,0,0,0,10.94-5.14Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.16,169.9c-.26,2.07-.46,4.52-.59,7.41a41.08,41.08,0,0,0,10.94-5.14Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,171c-5.26,4.66-25.34,4.19-25.34,4.19L316,155.75a148.17,148.17,0,0,0,20.47,1.48C347.66,157,347.74,165.86,342,171Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,171c-5.26,4.66-25.34,4.19-25.34,4.19L316,155.75a148.17,148.17,0,0,0,20.47,1.48C347.66,157,347.74,165.86,342,171Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.77,134.24l-5-5.89-5.39,6s3.32,5.58,8.59,4.7Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.61 121.48 260.67 129.17 264.34 134.31 269.73 128.35 262.61 121.48",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.75 392.64 339.13 401.4 346.48 401.4 346.1 392.64 338.75 392.64",
    style: {
      fill: "#ce6f64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.25 392.64 379.9 392.64 381.8 401.4 389.15 401.4 387.25 392.64",
    style: {
      fill: "#ce6f64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.17,123c-6.59-3-8.67-16.33,10.29-13,0,0-2.86,3.16,2.94,5.16S357.35,129.51,343.17,123Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.49,133c-1.89,7-2.63,11.26-7,14.19-6.54,4.4-14.67-.65-14.93-8.12-.23-6.71,2.9-17.1,10.45-18.52A9.94,9.94,0,0,1,357.49,133Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.2,113.5c4.49,2.5,10.57,4,10,7.56-.75,4.35,3.67,1.63,2.64,8.1-.67,4.23-8.47,17.05-14,16.43-8.26-1-7.21-13.56-7.24-20.18C344.58,121.5,344.4,108.57,353.2,113.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.61,119.11c-2,.47-4.65,12,3.1,13.06C355.62,133.38,343.61,119.11,343.61,119.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.81,123.2c-2.45.22-8-2.73-7.32-7.17C336.49,116,340,121.22,343.81,123.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.45,133.09a8.21,8.21,0,0,1-3.63,3.85c-2.11,1.1-3.3-.5-2.82-2.62.43-1.9,2.05-4.77,4.22-5S348.32,131.09,347.45,133.09Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.45,125a9.85,9.85,0,0,0,5.78-7.33S367.53,126.84,358.45,125Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.79,124.85a5.07,5.07,0,0,0-4.78-.47S365.09,120.39,366.79,124.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.57,222.78s8.34,56.14,12.91,77.17c5,23,23.9,99.76,23.9,99.76h13.45S379.38,324.84,376.52,302c-3.1-24.75-9.6-79.26-9.6-79.26Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.57,222.78s8.34,56.14,12.91,77.17c5,23,23.9,99.76,23.9,99.76h13.45S379.38,324.84,376.52,302c-3.1-24.75-9.6-79.26-9.6-79.26Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.23,394.75c-.06,0,1.39,5.17,1.39,5.17h15.14l-.28-4.61Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.23,394.75c-.06,0,1.39,5.17,1.39,5.17h15.14l-.28-4.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.84,242.78c9.64,1.89,8.62,37.84,7.46,56.33-2.78-13.07-6.85-38.22-9.63-56.07A3.29,3.29,0,0,1,346.84,242.78Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.84,242.78c9.64,1.89,8.62,37.84,7.46,56.33-2.78-13.07-6.85-38.22-9.63-56.07A3.29,3.29,0,0,1,346.84,242.78Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.63,222.78s-1,54.92-.21,77.33c.83,23.3,9,99.6,9,99.6h12.44s.46-74.94,1-97.82c.61-24.95,3.62-79.11,3.62-79.11Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.63,222.78s-1,54.92-.21,77.33c.83,23.3,9,99.6,9,99.6h12.44s.46-74.94,1-97.82c.61-24.95,3.62-79.11,3.62-79.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,390.77a.12.12,0,0,1-.12-.11c-2.2-21.12-7.37-72.22-8-90.55-.67-18.71-.06-60.69.14-73.11a.12.12,0,0,1,.12-.12h0a.13.13,0,0,1,.13.12c-.2,12.42-.81,54.4-.14,73.1.65,18.33,5.82,69.41,8,90.53a.14.14,0,0,1-.12.14Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,390.77a.12.12,0,0,1-.12-.11c-2.2-21.12-7.37-72.22-8-90.55-.67-18.71-.06-60.69.14-73.11a.12.12,0,0,1,.12-.12h0a.13.13,0,0,1,.13.12c-.2,12.42-.81,54.4-.14,73.1.65,18.33,5.82,69.41,8,90.53a.14.14,0,0,1-.12.14Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,394.75c-.05,0,.71,5.17.71,5.17h15.13l.41-4.61Z",
    style: {
      fill: "#6B5393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,394.75c-.05,0,.71,5.17.71,5.17h15.13l.41-4.61Z",
    style: {
      opacity: 0.1
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailsentRafiki);
export default __webpack_public_path__ + "static/media/Mail sent-rafiki.f2e9654195a69d904fa7c1f20caf1b77.svg";
export { ForwardRef as ReactComponent };